import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import Conflict from "./Conflict";
import GridConfig from "../GridConfig";

export default class Conflicts extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'conflict',
            IsV2: true,
            data: null,
            loading: true,
            configName: 'conflict_grid',
            moduleName: 'عناوین مغایرت گیری',
            filters: {
                usage: props.Usage
            }
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Conflict Caller={this} Id={id} Usage={this.state.filters.usage} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Conflict Caller={this} Usage={this.state.filters.usage} /> });
    }
    onGridConfig() {
        this.showComponents({ component: <GridConfig Caller={this} Config={this.getGridConfig()} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "name", caption: "عنوان", show: true }
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption, flex: 2 });
        });

        t.push({
            field: "", filter: false, flex: 1, headerName: "عملیات", cellRenderer: (props) => {
                return <ul className="flex flex-row">
                    <li>
                        <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(props.data.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                            <em className="icon ni ni-cross-fill-c"></em>
                        </a>
                        <a className="hand text-primary mx-1" onClick={e => this.onEdit(props.data.id)} title="ویرایش">
                            <em className="icon ni ni-pen"></em>
                        </a>
                    </li>
                </ul>
            }
        });
        return t;
    }
    getCaption() {
        if (this.state.filters.usage === 1) return "فاکتورها";
        if (this.state.filters.usage === 2) return "حواله/رسید ها";
        if (this.state.filters.usage === 3) return "دریافتها و پرداختها";
        if (this.state.filters.usage === 4) return "اسناد مالی";
        if (this.state.filters.usage === 5) return "صورتحسابهای مودیان";
        return "";
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">عناوین مغایرت گیری {this.getCaption()}</h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.getToolBar(false, {
                                    add: true, print: false, pdf: false, excell: false, remove: false, config: false,
                                    otherFilters: null
                                })}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}